<div class="card-footer-container">
  <u-button
    [label]="'Publish'"
    [type]="'primary'"
    (onClick)="publish()"
    [styles]="{ width: '96px', height: '32px' }"
    [loading]="publishInProgress"
  ></u-button>
</div>
